/**
 * The storage stack, built exactly once.
 *
 * This is the swap point the adapter seam was designed for: `LocalStorageAdapter`
 * still holds the data, `HybridAdapter` adds the cloud copy, and no component
 * knows which of them it is talking to.
 *
 * Module scope rather than a React ref on purpose — `attach()` in the progress
 * store memoises itself and runs once per page load, so these must outlive any
 * component and must not be rebuilt on a re-render.
 */

import { HybridAdapter } from '@/storage/HybridAdapter';
import { LocalStorageAdapter } from '@/storage/LocalStorageAdapter';
import { SyncEngine } from './syncEngine';

const local = new LocalStorageAdapter();

export const syncEngine = new SyncEngine({ local });

export const adapter = new HybridAdapter(local, syncEngine);
